import React from 'react';
import './EventCardActions.scss';

interface EventCardActionTokens {
    '--EventCardActionsMargin'?: string;
    '--EventCardActionsPadding'?: string;
    '--EventCardActionsPosition'?: string;
    '--EventCardActionsTop'?: string;
    '--EventCardActionsRight'?: string;
}

interface EventCardActionsProps {
    /**
     * Set of configurabe
     */
    tokens?: EventCardActionTokens;
    /**
     * Inserts the provided value under `actionStyle`
     * prop name to child components. Allows for
     * action wrapper to dictate expected appearance
     * to child actions that support the prop.
     */
    actionStyleOverride?: 'outline' | 'dark';
}

/**
 * Container element for rendering the event card actions. It supports
 * an option to inject `actionStyle` prop into children. This is
 * used in both EventCardSaveAction and EventCardShareAction as the
 * `style` prop passed into `IconButton`
 *
 * This allows for a single place to configure that value, and allow
 * for different event configurations to define their own visual
 * language for the actions.
 *
 * @param props
 * @returns
 */
export const EventCardActions: React.FunctionComponent<
    EventCardActionsProps
> = (props) => {
    if (!props.children) {
        return null;
    }

    let overwrittenChildren = null;

    if (props.actionStyleOverride) {
        overwrittenChildren = React.Children.map(props.children, (child) => {
            if (React.isValidElement(child)) {
                return React.cloneElement(child, {
                    ...child.props,
                    actionStyle: props.actionStyleOverride,
                });
            } else {
                return null;
            }
        });
    }

    return (
        <section
            className="event-card-actions"
            style={props.tokens as React.CSSProperties}
        >
            {overwrittenChildren ? overwrittenChildren : props.children}
        </section>
    );
};
